import { ApiService } from '~/services/api/api'
import type {
  SubmissionGroupWithStats,
  SubmissionGroup,
} from '~/types/SubmissionGroup'
import type { TestAttemptBatchSelectionParameters } from '~/types/TestAttemptBatchSelectionParameters'

export class TestSubmissionGroupsService {
  private readonly apiService = new ApiService()

  // TEST ATTEMPT GROUPS ==========================================
  async getTestSubmissionGroups(testId: string) {
    const response = await this.apiService.get<SubmissionGroupWithStats[]>(
      `/tests/${testId}/attempt-groups`,
    )
    return response
  }

  async createTestSubmissionGroup(
    testId: string,
    submissionGroup: Partial<SubmissionGroup>,
  ) {
    const response = await this.apiService.post<
      SubmissionGroup,
      Partial<SubmissionGroup>
    >(`/tests/${testId}/attempt-groups`, submissionGroup)
    return response
  }

  async updateTestSubmissionGroup(
    testId: string,
    submissionGroupId: string,
    submissionGroup: Partial<SubmissionGroup>,
  ) {
    const response = await this.apiService.patch<
      SubmissionGroup,
      Partial<SubmissionGroup>
    >(`/tests/${testId}/attempt-groups/${submissionGroupId}`, submissionGroup)
    return response
  }

  async deleteTestSubmissionGroup(testId: string, submissionGroupId: string) {
    const response = await this.apiService.delete<SubmissionGroup>(
      `/tests/${testId}/attempt-groups/${submissionGroupId}`,
    )
    return response
  }

  async assignSubmissionsToGroup(
    testId: string,
    groupId: string,
    selection: TestAttemptBatchSelectionParameters,
  ) {
    const response = await this.apiService.post<
      string,
      TestAttemptBatchSelectionParameters
    >(`/tests/${testId}/attempt-groups/${groupId}/attempts`, selection)
    return response
  }

  async removeSubmissionsFromGroup(
    testId: string,
    groupId: string,
    testAttemptIds: string[],
  ) {
    const response = await this.apiService.delete<string>(
      `/tests/${testId}/attempt-groups/${groupId}/attempts`,
      {
        data: testAttemptIds,
      },
    )
    return response
  }

  async gradeAllSubmissions(
    testId: string,
    groupId: string,
    regrade?: boolean,
  ) {
    const response = await this.apiService.post<string, Record<string, any>>(
      `/tests/${testId}/attempt-groups/${groupId}/grade?regrade=${regrade}`,
      {},
    )
    return response
  }

  async exportCSVResults(
    testId: string,
    groupId: string,
    withRemarks?: boolean,
  ) {
    const response = await this.apiService.get<string>(
      `/tests/${testId}/attempt-groups/${groupId}/results/csv?withRemarks=${withRemarks}`,
    )
    return response
  }
}
